import { Translate } from "../components/translate/Translate"

export const MonthNumber: any = () => {
    return {
        1: {
            translate: <Translate>month.jan</Translate>,
            translate_code: "month.jan",
            en_title: "January"
        },
        2: {
            translate: <Translate>month.feb</Translate>,
            translate_code: "month.feb",
            en_title: "February"
        },
        3: {
            translate: <Translate>month.mar</Translate>,
            translate_code: "month.mar",
            en_title: "March"
        },
        4: {
            translate: <Translate>month.apr</Translate>,
            translate_code: "month.apr",
            en_title: "April"
        },
        5: {
            translate: <Translate>month.may</Translate>,
            translate_code: "month.may",
            en_title: "May"
        },
        6: {
            translate: <Translate>month.jun</Translate>,
            translate_code: "month.jun",
            en_title: "June"
        },
        7: {
            translate: <Translate>month.jul</Translate>,
            translate_code: "month.jul",
            en_title: "July"
        },
        8: {
            translate: <Translate>month.aug</Translate>,
            translate_code: "month.aug",
            en_title: "August"
        },
        9: {
            translate: <Translate>month.sep</Translate>,
            translate_code: "month.sep",
            en_title: "September"
        },
        10: {
            translate: <Translate>month.oct</Translate>,
            translate_code: "month.oct",
            en_title: "October"
        },
        11: {
            translate: <Translate>month.nov</Translate>,
            translate_code: "month.nov",
            en_title: "November"
        },
        12: {
            translate: <Translate>month.dec</Translate>,
            translate_code: "month.dec",
            en_title: "December"
        }
    }
}